// src/services/api.js
import axios from 'axios';

const LMS_URL   = process.env.REACT_APP_LMS_URL   || 'http://localhost:5004/api/v1';
const API_URL   = process.env.REACT_APP_API_URL    || 'http://localhost:5002/api/v1';
const MEDIA_URL = process.env.REACT_APP_MEDIA_URL  || 'http://localhost:5001';

export const getToken  = () => localStorage.getItem('spa_token') || localStorage.getItem('mh_token');
export const setToken  = (t) => { localStorage.setItem('mh_token', t); localStorage.setItem('spa_token', t); };
export const clearAuth = () => { ['mh_token','mh_user','spa_token'].forEach(k => localStorage.removeItem(k)); };
export const getUser   = () => { try { return JSON.parse(localStorage.getItem('mh_user') || localStorage.getItem('user')); } catch { return null; } };
export const setUser   = (u) => { localStorage.setItem('mh_user', JSON.stringify(u)); };

export const resolveMedia = (url) => {
  if (!url) return null;
  return url.startsWith('http') ? url : `${MEDIA_URL}${url}`;
};

const authHeader = () => ({ Authorization: `Bearer ${getToken()}` });

const lms = axios.create({ baseURL: LMS_URL });
const api = axios.create({ baseURL: API_URL });

[lms, api].forEach(inst => {
  inst.interceptors.request.use(cfg => {
    const token = getToken();
    if (token) cfg.headers = { ...cfg.headers, Authorization: `Bearer ${token}` };
    return cfg;
  });
});

export const authAPI = {
  login:   (d) => api.post('/auth/login', d),
  me:      ()  => api.get('/auth/me'),
};

export const lmsAPI = {
  myDashboard:       ()           => lms.get('/my/dashboard'),
  myCourseProgress:  (cid)        => lms.get(`/my/courses/${cid}/progress`),
  myCertStatus:      (enrId)      => lms.get(`/my/enrollments/${enrId}/cert-status`),
  getCourse:         (id)         => lms.get(`/courses/${id}`),
  getCourseByProgram:(pid)        => lms.get(`/courses/program/${pid}`),
  getLesson:         (id)         => lms.get(`/lessons/${id}`),
  markComplete:      (lid, d)     => lms.post(`/lessons/${lid}/complete`, d),
  updateVideo:       (lid, d)     => lms.post(`/lessons/${lid}/video-progress`, d),
  startQuiz:         (lid, d)     => lms.post(`/quiz/${lid}/start`, d),
  submitQuiz:        (aid, d)     => lms.post(`/quiz/attempts/${aid}`, d),
  myAttempts:        (lid, enrId) => lms.get(`/quiz/${lid}/my-attempts`, { params: { enrollment_id: enrId } }),
  submit:            (lid, d)     => lms.post(`/lessons/${lid}/submit`, d),
  mySubmission:      (lid, enrId) => lms.get(`/lessons/${lid}/my-submission`, { params: { enrollment_id: enrId } }),
};

// Uses /upload/batch which accepts field name 'files' (array, max 10)
// Do NOT set Content-Type manually — let browser set it with boundary
export const uploadFiles = async (files) => {
  const fd = new FormData();
  files.forEach(f => fd.append('files', f));
  const res = await axios.post(`${MEDIA_URL}/api/media/upload/batch`, fd, {
    headers: { ...authHeader() },
  });
  return (res.data.data || []).map(f => f.file_url).filter(Boolean);
};

export default lms;